import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10dddbfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h1 data-v-10dddbfe>Vue Router</h1><p data-v-10dddbfe>Add the vue-router to your project: <code data-v-10dddbfe>yarn add vue-router@4</code></p><p data-v-10dddbfe><a target=\"_blank\" href=\"https://router.vuejs.org/\" data-v-10dddbfe>See docs</a></p><h2 data-v-10dddbfe>Generally speaking on routing</h2><p data-v-10dddbfe> Add a dynamic key to all router-view components using <code data-v-10dddbfe>$route.fullPath</code>. Ben Hong mentions three categories of routing: </p><h3 data-v-10dddbfe>Lazy loading</h3><p data-v-10dddbfe> Beyond landing page: import components dynamically! </p>", 7)
const _hoisted_8 = { id: "keys-block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Router keys", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Route keys", -1))
const _hoisted_11 = {
  key: 0,
  id: "container-route-object"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Full object of useRoute()", -1))
const _hoisted_13 = {
  key: 1,
  id: "container-router-object"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Full object of useRouter()", -1))

import {ref} from "vue";
import {useRoute, useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();

// eslint-disable-next-line no-undef
const displayRouterObject = ref(false);
const displayRouteObject = ref(false);

const routerKeys = Object.keys(router);
const routeKeys = Object.keys(route);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (displayRouterObject.value = !displayRouterObject.value))
    }, "Display router object"),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (displayRouteObject.value = !displayRouteObject.value))
    }, "Display route object"),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("pre", null, [
        _hoisted_9,
        _createTextVNode(_toDisplayString(_unref(routerKeys)), 1)
      ]),
      _createElementVNode("pre", null, [
        _hoisted_10,
        _createTextVNode(_toDisplayString(_unref(routeKeys)), 1)
      ])
    ]),
    (displayRouteObject.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("pre", null, _toDisplayString(_unref(route)), 1)
        ]))
      : _createCommentVNode("", true),
    (displayRouterObject.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("pre", null, "      " + _toDisplayString(_unref(router)) + "\n    ", 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})